export default "/static/dashboard/build/app/img/v2/51eb9ee54721153ec59038a752ddba55.png";